<!-- 相关政策信息 -->
<template>
  <div class="news">

    <div class="list">
      <div
        v-for="(item, index) in dataList"
        :key="index"
        @click="jumpD(item.id)"
      >
        <span class="list-left">
          <img src="./../../assets/27.png" alt="箭头" />
          <span>{{ item.title }}</span>
          </span>
        <span class="list-right">
          <img src="./../../assets/28.png" alt="时钟" />
          {{ item.create_time | dateFormat }}</span
        >
      </div>
    </div>

    <el-pagination
      style="text-align:center;margin-top:35px"
      background
      layout="prev, pager, next"
      :total="total"
      :page-size="20"
      @current-change="handleCurrentChange"
      @prev-click="handleCurrentChange"
      @next-click="handleCurrentChange"
    >
    </el-pagination>
  </div>
</template>

<script>
import { getArticleList } from "@/api/home";
import { getActive, setActive, removeActive } from "@/utils/auth";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      page: 1,
      total: 0,
      dataList: [],
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    handleCurrentChange(val) {
      this.page = val;
      this.fetchData();
    },
    jumpD(id) {
      this.$router.push({
        path: "/education/education-listd",
        query: {
          id: id,
        },
      });
      setActive('4-1')
      this.$store.dispatch("user/setActive", '4-1');
    },
    fetchData() {
      let params = {
        page: this.page,
        type: 2,
      };
      getArticleList(params).then((response) => {
        this.dataList = response.data;
        this.total = response.total;
      });
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.fetchData();
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
};
</script>
</script>
<style lang="scss" scoped>
.news {
  padding-top: 45px;
  padding-bottom: 50px;
  .line {
    width: 45px;
    height: 3px;
    margin-bottom: 50px;
    background-color: transparent;
  }
  .concent-full {
    margin-top: 25px;
    margin-bottom: 50px;
    height: 270px;
    .full-left {
      width: 395px;
      height: 100%;
      float: left;
      img {
        display: inline-block;
        width: 100%;
        height: 100%;
        background-color: gray;
      }
    }
    .full-right {
      margin-left: 35px;
      width: 395px;
      float: left;
      @media screen and (max-width: 768px) {
        width: 95%;
        margin-left: 0px;
      }
      .full-title {
        font-size: 18px;
        color: #286ab6;
        font-weight: 600;
        margin-bottom: 20px;
      }
      .full-date {
        font-size: 14px;
        color: #296bb7;
        margin-bottom: 20px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        img {
          display: inline-block;
          width: 30px;
          height: 30px;
        }
      }
      div {
        font-size: 14px;
        height: 145px;
        line-height: 25px;
        color: #5d5d5d;
      }
      button {
        width: 150px;
        height: 40px;
        outline: none;
        border: none;
        background-color: #f4f4f4;
        font-size: 16px;
        color: #333333;
        cursor: pointer;
        @media screen and (max-width: 992px) {
          font-size: 14px;
        }
      }
    }
  }
  .list {
    width: 100%;
    height: 100%;
    div:nth-child(even) {
      background-color: #ffffff;
    }
    div:nth-child(odd) {
      background-color: #f4f4f4;
    }
    div {
      width: 100%;
      height: 50px;
      line-height: 50px;
      padding-left: 20px;
      padding-right: 20px;
      color: #343434;
      cursor: pointer;
      font-size: 16px;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      word-break: break-all;
      @media screen and (max-width: 992px) {
        font-size: 14px;
      }
      .list-left {
        display: flex;
        justify-content: center;
        align-items: center;
        @media screen and (max-width: 768px) {
          font-size: 14px;
          width: 95%;
        }
        img {
          display: inline-block;
          margin-right: 15px;
          width: 10px;
          height: 10px;
        }
        float: left;
        span {
          @media screen and (max-width: 768px) {
            width: 95%;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            word-break: break-all;
          }
        }
      }
      .list-right {
        float: right;
        display: flex;
        justify-content: center;
        align-items: center;
        @media screen and (max-width: 768px) {
          font-size: 14px;
          display: none;
        }
        img {
          display: inline-block;
          width: 30px;
          height: 30px;
        }
      }
    }
  }
}
</style>
